export const bars = {
	title: "Bares",
	description: "Operadores vinculados a esses bares terão esses produtos disponiveis",
	actions: {
		linkBars: "Adicionar aos bares",
		unlinkBars: "Desvincular bar",
		linkBar: "Vincular bar",
		unlinkBar: "Desvincular bar",
		addAll: "Adicionar todos",
		removeAll: "Remover todos",
		next: "Próximo",
		back: "Voltar",
	},
	notifications: {
		success: "Produto vinculado com sucesso aos bares selecionados.",
		error: "Algumas vinculações falharam. Tente novamente mais tarde.",
		genericError: "Erro ao vincular produto aos bares. Tente novamente mais tarde.",
		unlinkSuccess: "Produto desvinculado com sucesso do bar.",
		genericUnlinkError: "Erro ao desvincular produto do bar. Tente novamente mais tarde.",
	},
	unlinkBarsConfirmation: {
		title: "Desvincular bar",
		message:
			"Deseja remover o vinculo com este bar? Se sim, seu produto não estará mais disponivel para consumo no bar.",
		confirm: "Desvincular bar",
		cancel: "Cancelar",
	},
	labels: {
		linkedBars: "Bares vinculados",
		optional: "Opcional",
		selectBars: "Escolha os bares que seu produto ficará ativo.",
		stock: "Estoque",
		ip: "IP Impressora",
	},
	fields: {
		searchLabel: "Bares disponíveis",
		searchPlaceholder: "Pesquise um bar",
	},
	emptyState: {
		title: "Ainda não existem bares vinculados",
		description: "Adicione bares para disponibilizar este produto",
	},
};
